<template>
  <hr class="divider" />
</template>

<style scoped>
@import "Divider.css";
</style>
